// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__EcH9I","buttonDisabled":"styles_buttonDisabled__qgMj0"};